import React, { useState } from "react";

import "./EditableInformationStatus.css";
import { ListStatusDisplay } from "../../ListStatusDisplay/ListStatusDisplay";
import { Icon } from "../../../Icon/Icon";
import { useTranslation } from "react-i18next";
import { EditableInformationTextSelect } from "../EditableInformation";
import { Button } from "../../Button/Button";
import { Form, Formik } from "formik";
import { knownLanguages } from "../../../../knownLanguages";

export const EditableInformationStatus = ({
  label,
  value,
  onSubmit = () => {},
  validationSchema,
  name,
  options = [],
  editable = true,
  withSquare,
  isLang = false,
}) => {
  const { t } = useTranslation();
  const [isEditing, setIsEditing] = useState(false);

  return (
    <div
      className={
        isEditing
          ? "EditableInformationDisplay EditableInformationDisplay--editing"
          : "EditableInformationDisplay"
      }
    >
      <div className="EditableInformationDisplay__label">
        <div className="EditableInformationDisplay__label--text">
          {t(label)}
        </div>
      </div>
      <div className="EditableInformationDisplay__value">
        {!isEditing && isLang && (
          <ListStatusDisplay
            status={knownLanguages.find((lang) => lang?.value === value)?.label}
            withSquare={withSquare}
          />
        )}
        {!isEditing && !isLang && (
          <ListStatusDisplay status={value} withSquare={withSquare} />
        )}
        {isEditing && (
          <Formik
            initialValues={{
              [name]: value,
            }}
            onSubmit={(data) => {
              setIsEditing(false);
              onSubmit(data);
            }}
            validationSchema={validationSchema}
          >
            {({ isValid, dirty }) => {
              return (
                <Form
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <div className="EditableInformationDisplay__value EditableInformationDisplay__value--editing">
                    <EditableInformationTextSelect
                      name={name}
                      options={options}
                      type="text"
                      withSquare={withSquare}
                      defaultEditingState={true}
                    />
                  </div>
                  <div className="EditableInformationDisplay__action">
                    <Button
                      buttonStyle="EditableInformationDisplay__action-button"
                      click={() => {
                        setIsEditing(false);
                      }}
                    >
                      <Icon name="iconCross" width={14} height={14} />
                    </Button>
                    <Button
                      buttonStyle="EditableInformationDisplay__action-button"
                      type="submit"
                      disabled={!isValid || !dirty}
                    >
                      <Icon name="iconCheckmark" width={14} height={18} />
                      <div className="EditableInformationDisplay__action-button-text">
                        {t("Save")}
                      </div>
                    </Button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        )}
      </div>
      {editable && (
        <div
          className="EditableInformationDisplay__action"
          onClick={() => setIsEditing(true)}
        >
          {!isEditing && <Icon name="iconEdit" width={14} height={18} />}
        </div>
      )}
    </div>
  );
};
